module.exports = __webpack_public_path__ + "static/navigate-circle.43ac6244.svg";